import { render, staticRenderFns } from "./poster.vue?vue&type=template&id=0bfea4b0&scoped=true"
import script from "./poster.vue?vue&type=script&lang=ts"
export * from "./poster.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfea4b0",
  null
  
)

export default component.exports